import { useCallback } from 'react';
import useEventListenerOutside from './useEventListenerOutside';
var useOnFocusOutside = function useOnFocusOutside(handler, refs) {
  var callback = useCallback(function (event) {
    if (event.eventPhase === Event.BUBBLING_PHASE && refs.some(function (ref) {
      return ref.current && event.target.contains(ref.current);
    })) return;
    handler(event);
  }, [handler, refs]);
  useEventListenerOutside(callback, 'focusin', refs);
};
export default useOnFocusOutside;